import React from 'react';
import styled from 'styled-components';
import { colors, gradients, typography, transitions, mixins } from '../../styles/theme';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  ${props => props.$clickable && 'cursor: pointer;'}
  transition: ${transitions.default};

  &:hover {
    ${props => props.$clickable && 'transform: scale(1.05);'}
  }
`;

const LogoImage = styled.img`
  height: ${props => props.$height || '40px'};
  width: auto;
  object-fit: contain;
  transition: ${transitions.default};
  
  @media (max-width: 768px) {
    height: ${props => props.$mobileHeight || '32px'};
  }
  
  @media (max-width: 400px) {
    height: ${props => props.$mobileHeight || '28px'};
  }
`;

const LogoText = styled.span`
  color: ${colors.white};
  font-size: ${props => props.fontSize || '2rem'};
  font-weight: ${typography.weights.extrabold};
  text-decoration: none;
  transition: ${transitions.default};
  ${mixins.textGradient(gradients.primary)};
  letter-spacing: -0.02em;
  margin-left: ${props => props.imageOnly ? '0' : '0.5rem'};

  @media (max-width: 768px) {
    font-size: ${props => props.mobileFontSize || '1.8rem'};
  }

  @media (max-width: 400px) {
    font-size: ${props => props.mobileFontSize || '1.5rem'};
  }
`;

const Logo = ({ 
  src, 
  alt = "Creanity Logo", 
  height = "40px", 
  mobileHeight = "32px",
  fontSize = "2rem",
  mobileFontSize = "1.8rem",
  showText = true, 
  imageOnly = false,
  className,
  onClick,
  ...props 
}) => {
  const [imageError, setImageError] = React.useState(false);
  const hasImage = src && src !== '' && !imageError;
  
  // Eğer logo varsa sadece logo göster, yoksa text göster
  const shouldShowText = imageError || !src || (!imageOnly && showText && !hasImage);
  const shouldShowImage = hasImage && src;

  return (
    <LogoContainer 
      $clickable={!!onClick} 
      onClick={onClick}
      className={className}
      {...props}
    >
      {shouldShowImage && (
        <LogoImage 
          src={src} 
          alt={alt}
          $height={height}
          $mobileHeight={mobileHeight}
          onError={() => setImageError(true)}
          loading="lazy"
          decoding="async"
        />
      )}
      {shouldShowText && (
        <LogoText 
          fontSize={fontSize}
          mobileFontSize={mobileFontSize}
          imageOnly={imageOnly}
        >
          Creanity
        </LogoText>
      )}
    </LogoContainer>
  );
};

export default Logo; 